import { useContext } from 'react';
import { FinanceHeaderContext } from '../components/context/FinanceHeaderContextProvider';

const useFinanceHeader = () => {
  const {
    header,
    subHeader,
    component,
    setHeader,
    setSubHeader,
    setComponents,
  } = useContext(FinanceHeaderContext);
  return {
    header,
    subHeader,
    component,
    setHeader,
    setSubHeader,
    setComponents,
  };
};

export default useFinanceHeader;
